import React from 'react';
import classNames from 'classnames';

import css from './ListingViewsCount.module.css';

const toInt = v => {
  if (typeof v === 'number' && Number.isFinite(v)) return Math.trunc(v);
  if (typeof v === 'string' && v.trim() !== '' && !Number.isNaN(Number(v))) return Math.trunc(Number(v));
  return 0;
};

/**
 * ListingViewsCount
 * Renders an eye icon + formatted views count like "(08)".
 *
 * @param {Object} props
 * @param {Object?} props.publicData listing publicData
 * @param {number|string?} props.viewsCount optional explicit views count override
 * @param {string?} props.className add more style rules in addition to component's own css.root
 * @param {string?} props.rootClassName overwrite component's own css.root
 */
const ListingViewsCount = props => {
  const { publicData, viewsCount, className, rootClassName } = props;
  const raw = typeof viewsCount !== 'undefined' ? viewsCount : publicData?.viewsCount;
  const count = Math.max(0, toInt(raw));

 if (!count) return null;

  const formatted = String(count);
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes} aria-label={`Views (${formatted})`}>
      <svg
        className={css.icon}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        shapeRendering="geometricPrecision"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M0.666992 7.99999C0.666992 7.99999 3.33366 2.66666 8.00033 2.66666C12.667 2.66666 15.3337 7.99999 15.3337 7.99999C15.3337 7.99999 12.667 13.3333 8.00033 13.3333C3.33366 13.3333 0.666992 7.99999 0.666992 7.99999Z"
          stroke="currentColor"
          fill="none"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
          stroke="currentColor"
          fill="none"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className={css.value}>({formatted})</span>
    </div>
  );
};

export default ListingViewsCount;
